export default "__VITE_ASSET__DCkZpmCV__"